import { Header, Section } from '@components';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useMediaQueries } from '@hooks';
import { useRef } from 'react';
import BakeryDiningIcon from '@mui/icons-material/BakeryDining';
import classnames from 'classnames';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import TapasIcon from '@mui/icons-material/Tapas';
import WineBarIcon from '@mui/icons-material/WineBar';

export default function Offerings({ header, offerings }) {
  const { isMobile } = useMediaQueries();
  const sliderRef = useRef(null);

  const svgBySlug = (slug) => {
    switch (slug) {
      case 'colazione':
        return (
          <BakeryDiningIcon
            key="breakfast"
            fontSize="extra-large"
            color="primary"
            className="w-40 mx-auto"
          />
        );
      case 'pranzi':
        return (
          <DinnerDiningIcon
            key="lunches"
            fontSize="large"
            color="primary"
            className="w-40 mx-auto"
          />
        );
      case 'cene':
        return (
          <LocalPizzaIcon
            key="dinners"
            fontSize="large"
            color="primary"
            className="w-40 mx-auto"
          />
        );
      case 'aperitivi':
        return (
          <WineBarIcon
            key="aperitifs"
            fontSize="large"
            color="primary"
            className="w-40 mx-auto"
          />
        );

      case 'degustazioni':
        return (
          <TapasIcon
            key="tastings"
            fontSize="large"
            color="primary"
            className="w-40 mx-auto"
          />
        );
      case 'eventi':
        return (
          <LocalBarIcon
            key="events"
            fontSize="large"
            color="primary"
            className="w-40 mx-auto"
          />
        );

      default:
        break;
    }
  };
  return (
    <Section fullWidth>
      <Header
        fullWidth
        title={header?.title}
        label={header?.label}
        description={header?.description}
      />

      {offerings?.length > 0 && (
        <>
          {isMobile ? (
            <>
              <Splide
                tag="section"
                ref={sliderRef}
                options={{
                  drag: true,
                  type: 'slide',
                  width: '100%',
                  height: '100%',
                  autoplay: true,
                  pagination: true,
                  arrows: false,
                  padding: 0,
                  rewind: true,
                  snap: true,
                  perPage: 1,
                  perMove: 1,
                  focus: 0,
                  flickPower: 800,
                  flickMaxPages: 1,
                  lazyLoad: 'nearby',
                  video: {
                    loop: true,
                    mute: true,
                  },
                }}
              >
                {offerings?.map(({ attributes }, i) => {
                  const { type, slug } = attributes;
                  return (
                    <SplideSlide key={i}>
                      <div
                        className={classnames(
                          'flex flex-col justify-center items-center space-y-2 pb-10',
                        )}
                      >
                        {svgBySlug(slug)}
                        <h2
                          className={classnames('text-2xl', 'body')}
                        >
                          {type}
                        </h2>
                      </div>
                    </SplideSlide>
                  );
                })}
              </Splide>
            </>
          ) : (
            <div
              className={classnames(
                'mt-8 mx-auto pt-10',
                'flex justify-center',
                'gap-4 lg:gap-8',
              )}
            >
              {offerings?.map(({ attributes }, i) => {
                const { type, slug } = attributes;
                return (
                  <div
                    key={i}
                    className={classnames(
                      'flex flex-col justify-center items-center space-y-2',
                    )}
                  >
                    {svgBySlug(slug)}
                    <h2 className={classnames('text-2xl', 'body')}>
                      {type}
                    </h2>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </Section>
  );
}
